import type { VarianteDetaillee } from '@/types/api';

/**
 * La rédaction qui porte (ou a pour modèle) le couple `coupleId`. Après un rechargement,
 * le regroupement des rédactions peut désigner un autre couple comme modèle : retrouver la
 * sélection par appartenance plutôt que par identifiant de modèle évite de perdre la
 * rédaction en cours d'édition.
 */
export function varianteDuCouple(
  variantes: VarianteDetaillee[],
  coupleId: number | null,
): VarianteDetaillee | null {
  if (coupleId === null) return null;
  return (
    variantes.find((v) => v.coupleModeleId === coupleId) ??
    variantes.find((v) => v.metiers.some((m) => m.coupleId === coupleId)) ??
    null
  );
}

/** Message affiché après un « Appliquer à tous » réussi. */
export function messageHarmonisation(codeActivite: string, nbMetiersAffectes: number): string {
  return (
    `Rédaction appliquée : ${nbMetiersAffectes} autre(s) métier(s) portant ${codeActivite} ` +
    'ont été alignés. Les mots-clés de chaque métier sont conservés.'
  );
}
